(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("grapesjs"));
	else if(typeof define === 'function' && define.amd)
		define(["grapesjs"], factory);
	else if(typeof exports === 'object')
		exports["grapesjs-shape-divider"] = factory(require("grapesjs"));
	else
		root["grapesjs-shape-divider"] = factory(root["grapesjs"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 